import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37fbbc14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = {
  class: "p-col-6",
  style: {"margin":"auto","text-align":"left","padding-left":"20px"}
}
const _hoisted_3 = { class: "p-col-4" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Local only")
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "p-col-2",
  style: {"margin":"auto"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, {
      style: _normalizeStyle(_ctx.selected ? 'border-style: solid; -webkit-box-sizing: border-box;' : '')
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, _toDisplayString(_ctx.token?.name), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.token_meta?.entity?.tag), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.token_meta?.entity && _ctx.token_meta?.entity?.platform != 'opensea')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_4
                ], 64))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.token?.image_thumbnail_url,
                  style: {"height":"50px"}
                }, null, 8, _hoisted_5))
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.in_playlist)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-button-text",
                  icon: "pi pi-list",
                  style: {color: '#000000'},
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit("togglePlaylistToken", false)), ["stop"]))
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "p-button-text",
                  icon: "pi pi-plus",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit("togglePlaylistToken", true)), ["stop"]))
                }))
          ])
        ])
      ]),
      _: 1
    }, 8, ["style"])
  ]))
}